import { Box, SvgIcon } from '@mui/material';
import BoltIcon from 'assets/icons/bolt.svg';
import StarSignIcon from 'assets/icons/star-sign.svg';
import StarIcon from 'assets/icons/star.svg';
import FileExcelBoxIcon from 'mdi-react/FileExcelBoxIcon';
import FileIcon from 'mdi-react/FileIcon';
import FilePdfBoxIcon from 'mdi-react/FilePdfBoxIcon';
import FilePowerpointBoxIcon from 'mdi-react/FilePowerpointBoxIcon';
import FileWordBoxIcon from 'mdi-react/FileWordBoxIcon';
import ForbidIcon from 'mdi-react/ForbidIcon';
import ImageIcon from 'mdi-react/ImageIcon';
import MicrophoneIcon from 'mdi-react/MicrophoneIcon';
import TextLongIcon from 'mdi-react/TextLongIcon';
import TextShortIcon from 'mdi-react/TextShortIcon';
import VideocamIcon from 'mdi-react/VideocamIcon';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import messageShape from 'shapes/message';
import parseFileName from 'utils/getFileExtension';
import { getMessageType, MESSAGE_TYPES } from 'utils/getMessageType';
import resolvePreviewImageSrc from 'utils/resolvePreviewImageSrc';

const styles = {
  img: { width: '1.3em', height: '1.3em', objectFit: 'cover', borderRadius: 3 },
  imgCover: { width: '100%', height: '100%', objectFit: 'cover' },
  icon: { fontSize: '1.1em', verticalAlign: 'text-bottom' },
  iconDeleted: { color: 'secondary.main', fontSize: 18 },
};

const MessageIcon = ({
  message = null,
  showImages = true,
  textIcon = false,
  coverImages = false,
}) => {
  const [preferHttpLink, setPreferHttpLink] = useState(false);
  const [imageBroken, setImageBroken] = useState(false);

  if (!message) {
    return null;
  }
  const extIcons = {
    pdf: FilePdfBoxIcon,
    doc: FileWordBoxIcon,
    docx: FileWordBoxIcon,
    xls: FileExcelBoxIcon,
    xlsx: FileExcelBoxIcon,
    ppt: FilePowerpointBoxIcon,
    pptx: FilePowerpointBoxIcon,
  };
  const { ext } = parseFileName(message.attachments?.[0]?.name || '');
  const icons = {
    [MESSAGE_TYPES.ACKNOWLEDGE]: message.digitalSignature ? StarSignIcon : StarIcon,
    [MESSAGE_TYPES.FORM]: BoltIcon,
    [MESSAGE_TYPES.AUDIO]: MicrophoneIcon,
    [MESSAGE_TYPES.IMAGE]: ImageIcon,
    [MESSAGE_TYPES.VIDEO]: VideocamIcon,
    [MESSAGE_TYPES.FILE]: extIcons[ext] || FileIcon,
    [MESSAGE_TYPES.TEXT]: textIcon ? TextShortIcon : null,
    [MESSAGE_TYPES.ARTICLE]: textIcon ? TextLongIcon : null,
  };
  const attachment = message.attachments?.[0];
  const type = getMessageType(message);
  const Icon = message.softDeletedAt ? ForbidIcon : icons[type];
  const imageSrc = imageBroken
    ? null
    : resolvePreviewImageSrc(attachment, { showImages, preferHttpLink });
  const httpFallbackSrc = resolvePreviewImageSrc(attachment, {
    showImages,
    preferHttpLink: true,
  });

  if (!imageSrc && Icon) {
    return (
      <SvgIcon sx={message.softDeletedAt ? styles.iconDeleted : styles.icon}>
        <Icon />
      </SvgIcon>
    );
  }
  if (imageSrc) {
    return (
      <Box
        component="img"
        alt=""
        src={imageSrc}
        sx={coverImages ? styles.imgCover : styles.img}
        onError={() => {
          if (!preferHttpLink && httpFallbackSrc && httpFallbackSrc !== imageSrc) {
            setPreferHttpLink(true);
            return;
          }
          setImageBroken(true);
        }}
      />
    );
  }
  return null;
};

MessageIcon.propTypes = {
  message: messageShape,
  showImages: PropTypes.bool,
  textIcon: PropTypes.bool,
  coverImages: PropTypes.bool,
};
export default MessageIcon;
